// extracted by mini-css-extract-plugin
module.exports = {"content":"FormPanel_content__jZVnY","required":"FormPanel_required__2VpDg","withMargins":"FormPanel_withMargins__2n-JJ"};